import { computed, ref } from 'vue'

import { defineStore } from 'pinia'
import { projectService } from '@/database/services'

type ProjectData = Record<string, any> | null

export const useProjectDataStore = defineStore('projectData', () => {
  const projectData = ref<ProjectData>(null)
  const error = ref<string | null>(null)


  const setProjectData = (data: ProjectData) => {
    projectData.value = data
    console.log('projectData', projectData.value)
  }

  const clearProjectData = () => {
    projectData.value = null
  }

  const fetchProjectData = async (projectId: string) => {
    try {
      error.value = null
      const data = await projectService.getByIdWithTeam(projectId)
      setProjectData(data)
      console.log('fetched new projectData', data)
      return data
    } catch (err: any) {
      error.value = err?.message || 'Failed to fetch project data'
      console.error('Error fetching project data:', err)
      throw err
    }
  }

  const getProjectData = async (projectId?: string, forceRefresh = false) => {
    console.log('getProjectData', projectId, forceRefresh)
    if(!projectId) {
      console.log('returning cached projectData', projectData.value)
        return projectData.value
    }
    if(!forceRefresh && projectData.value?.id === projectId) {
      console.log('returning cached projectData', projectData.value)
        return projectData.value
    }
    console.log('fetching new projectData', projectId)
    return await fetchProjectData(projectId)
  }

  return {
    projectData,
    error,
    setProjectData,
    getProjectData,
    clearProjectData
  }
})
